export default "__VITE_ASSET__bce5f6c3__"